export const HOME_EXIT = 'ty://?Page=CloseDigitalServices';
export const WALLET = 'ty://?Page=MyWallet';
export const WALLET_HISTORY = 'ty://?Page=MyWalletHistory';
export const OUT_WEB = 'ty://?Page=OutWeb&WebUrl=';
